const ChevronDownIcon = () => (
  <svg className="w-4 h-4 group-hover:translate-y-0.5 transition-transform duration-200"
    fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
  </svg>
)

/**
 * Load more pagination button.
 * @param {{ onClick: () => void, remaining: number }} props
 */
const LoadMoreButton = ({ onClick, remaining }) => (
  <div className="flex flex-col items-center gap-2 mt-10">
    <button
      onClick={onClick}
      className="group flex items-center gap-2.5
        bg-white border-2 border-brand-200 hover:border-brand-500
        text-brand-600 hover:text-brand-700
        font-bold text-sm
        px-8 py-3 rounded-2xl
        shadow-sm hover:shadow-lg hover:shadow-brand-100
        transition-all duration-200 active:scale-95"
    >
      <span>Load More Deals</span>
      <ChevronDownIcon />
      <span className="text-xs font-normal text-slate-400">
        ({remaining} more)
      </span>
    </button>
  </div>
)

export default LoadMoreButton
